// extracted by mini-css-extract-plugin
module.exports = {"content":"_1wc1yYiYBVMrl_qdEfladA"};